import { hexToRGBA } from 'src/@core/utils/hex-to-rgba'

/**
 * Defaults for the checkout preview, used until the merchant overrides a colour
 * on the payment page. Values mirror checkout-ui's own fallbacks, so the preview
 * and the live checkout render the same plan card.
 */
export const DEFAULT_RIBBON = '#009966'
export const DEFAULT_NUDGE = '#FFC400'
export const DEFAULT_RING = '#000000'
export const DEFAULT_STRIP_TEXT = '#5E3F02'
export const DEFAULT_MORE_PLANS_TEXT = '#3F3F46'
export const DEFAULT_ICON = 'var(--flo-primary-dark-color)'
export const DEFAULT_OFFER_PILL = 'linear-gradient(90deg, rgba(0, 153, 102, 0.71) 0%, #009966 100%), #FFFFFF'

const NUDGE_TEXT_EDGE = 'rgba(0, 0, 0, 0.7)'

/** Placeholder amounts: the preview has no cart, so prices are never real. */
export const PRICE_PLACEHOLDER = '₹ XXX'
export const STRIKE_PLACEHOLDER = '₹XXX'

/** Neutral fills for the mocked product thumbnail and shipping chevron. */
export const PLACEHOLDER_THUMBNAIL_FILL = 'bg-[#F3F3F3]'
export const PLACEHOLDER_CHEVRON_FILL = 'bg-[#F4F4F4]'

/**
 * The preview is a scale model of the checkout widget, so its type is sized to
 * the phone frame rather than to the dashboard's text tokens. Kept here so the
 * sizes are declared once and stay consistent across the preview components.
 */
export const PREVIEW_TEXT = {
  sheetTitle: 'text-[17px] font-semibold leading-[22px]',
  sheetSubtitle: 'text-[13px] font-medium leading-[17px]',
  ribbonLabel: 'text-[9.5px] font-semibold leading-[15px]',
  planTitle: 'text-[15px] leading-[19px]',
  planPrice: 'text-[15px] font-medium leading-[19px]',
  planMeta: 'text-[11px] font-medium leading-[14px]',
  cardTitle: 'text-[14px] font-semibold leading-[18px]',
  cardSubtitle: 'text-[12px] font-medium leading-[15px]',
  cardPrice: 'text-[14px] font-medium leading-[18px]',
  offerPill: 'text-[10px] font-bold leading-[15px]',
  discountPill: 'text-[10px] font-bold leading-[12px]',
  morePlans: 'text-[10px] font-semibold leading-[13px]'
}

export const ribbonGradient = (color: string) => `linear-gradient(90deg, ${color} 0%, ${hexToRGBA(color, 0)} 100%)`

export const nudgeTextGradient = (color?: string) =>
  `linear-gradient(90deg, ${NUDGE_TEXT_EDGE} 0%, ${color || DEFAULT_NUDGE} 56.25%, ${NUDGE_TEXT_EDGE} 100%)`

export const highlightGradient = (color?: string) => {
  const base = color || DEFAULT_RIBBON

  return `linear-gradient(90deg, ${hexToRGBA(base, 0.2)} 0%, ${base} 49.52%, ${hexToRGBA(base, 0.2)} 100%)`
}

export const MORE_PLANS_STRIP = highlightGradient()
